// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"VideosCard_videoCard__2Q1mR","letterHover":"VideosCard_letterHover__2Wbeg","videoImage":"VideosCard_videoImage__3dbVl","videoTitle":"VideosCard_videoTitle__3llZL"};